import Axios from "axios";

export class ProveedorPjService {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pj/lista?${queryParams}`).then(res => res.data);
    }

    newProveedor(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pj/nuevo`, data).then(res => res.data);
    }

    editarProveedor(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pj/editar`, data).then(res => res.data);
    }

    eliminarProveedor(id) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pj/eliminar/${id}`).then(res => res.data);
    }

    consultarProveedor(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pj/consulta/${id}`, { params: opciones }).then(res => res.data);
    }

    descargar(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/proveedor-pj/reporte/${id}`, {
            params: opciones,
            headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' }, responseType: 'blob'
        }).then(async res => res.data);
    }
}
